import type { TablePagination } from './types';

/** Page arithmetic, separate so it can be tested on its own. */
export function paginatorState(pagination: TablePagination, pageItemCount: number | null) {
  const { pageIndex, pageSize, totalCount, hasNextPage } = pagination;
  const known = totalCount !== null;
  const totalPages = known && totalCount > 0 && pageSize > 0 ? Math.ceil(totalCount / pageSize) : 0;
  const start = totalCount === 0 ? 0 : pageIndex * pageSize + 1;
  const end = known
    ? Math.min((pageIndex + 1) * pageSize, totalCount)
    : pageItemCount === null
      ? (pageIndex + 1) * pageSize
      : pageIndex * pageSize + pageItemCount;
  const isFirst = pageIndex === 0;
  const isLast = known ? pageIndex >= totalPages - 1 : !hasNextPage;
  return { known, totalPages, start, end, isFirst, isLast };
}

/**
 * The 0-based page indexes to offer as numbered boxes: up to `size` pages centred on the current
 * one (`p-2 … p+2`), shifted to stay inside `0 … totalPages-1` near the ends.
 */
export function pageWindow(pageIndex: number, totalPages: number, size = 5): number[] {
  if (totalPages <= 0) {
    return [];
  }
  const count = Math.min(size, totalPages);
  const first = Math.min(Math.max(0, pageIndex - Math.floor(size / 2)), totalPages - count);
  return Array.from({ length: count }, (_, offset) => first + offset);
}
